import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { SidebarTreeSchema } from '../shared/schemas/sidebarTree.js';

export * from '../shared/schemas/sidebarTree.js';

export const getSidebarListQueryOptions = defaultClient.query({
  url: 'planning-service/meta/planning/navigation/' as const,
  method: 'GET',
  responseSchema: SidebarTreeSchema,
  querySchema: z.object({
    mediaDataId: z.string(),
  }),
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});
